import { useState } from 'react';

interface PasswordFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  minLength?: number;
  required?: boolean;
}

export function PasswordField({
  label,
  value,
  onChange,
  autoComplete = 'new-password',
  minLength,
  required = true,
}: PasswordFieldProps): JSX.Element {
  const [visible, setVisible] = useState(false);

  return (
    <label>
      <span>{label}</span>
      <div className="password-field">
        <input
          value={value}
          onChange={(event) => onChange(event.target.value)}
          type={visible ? 'text' : 'password'}
          required={required}
          minLength={minLength}
          autoComplete={autoComplete}
        />
        <button
          className="password-field__toggle"
          type="button"
          aria-pressed={visible}
          aria-label={visible ? 'Hide password' : 'Show password'}
          onClick={() => setVisible((current) => !current)}
        >
          {visible ? 'Hide' : 'Show'}
        </button>
      </div>
    </label>
  );
}
